<template>

</template>
<script>
  /**
   * provides shared functionality for Intro- and MainInteractionContainer
   * used to control the status of the next button
   * whenever an item is answered, the next button is enabled - as soon as the answer
   * is sent to the backend and the next item is displayed, the button is disabled via resetData()
   *
   * we pass the 'clicking' of the next button to the children, because some components/items
   * take different action on the click instead of incrementing item (at the moment only outcome task)
   */
  import { mapGetters, mapActions } from 'vuex'
  import { RESULTS } from '@/constants/interaction'

  export default {
    name: 'InteractionContainerMixin',
    props: {
      interactionInstanceToken: {
        type: String
      },
      interactionInstace: {
        type: Object
      }
    },
    computed: {
      ...mapGetters([
        'interactionInstance',
        'isLastItem',
        'currentItem',
        'currentItemNumber',
        'partItems',
        'locale'
      ]),
      activePart() {
        if(this.partItems && this.partItems.length > 0) {
          const activePart = [...this.partItems]
            .reverse()
            .find(item => item.number <= this.currentItemNumber) || this.partItems[0]

          return activePart
        }
      }
    },
    watch: {
      partItems() {
        this.updateColorVariant()
      },
      currentItem() {
        if (this.currentItem) {
          this.resetData()
        }
      },
    },
    data() {
      return {
        // dis-/enables next button
        itemAnswered: false,
        // indicates if next button was clicked for child components to take specific action
        nextClicked: false,
      }
    },
    methods: {
      ...mapActions([
        'setColorVariant'
      ]),
      handleAnswer(isAnswered) {
        this.itemAnswered = isAnswered
      },
      resetData() {
        this.nextClicked = false
        this.itemAnswered = false
      },
      resetAfterDataTransmissionError() {
        this.nextClicked = false;
        this.itemAnswered = true;
      },
      handleNext() {
        if (this.itemAnswered && !this.isLastItem) {
          this.nextClicked = true
        }
      },

      updateColorVariant() {
        if(this.partItems && this.partItems.length > 0) {
          const activePart = [...this.partItems]
            .reverse()
            .find(item => item.number <= this.currentItemNumber) || this.partItems[0]

          this.setColorVariant(activePart.variant)
        }
      }
    },
    mounted() {
      this.updateColorVariant()
    }
  }
</script>
